import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

export const RecallLevelSelect = ({ ...props }) => {
  const [ t ] = useTranslation();

  const options = [
    { text: t('fields.recallLevel.supplier'), value: '1' },
    { text: t('fields.recallLevel.warehouse'), value: '2' },
    { text: t('fields.recallLevel.p/c'), value: '3' },
    { text: t('fields.recallLevel.endUser'), value: '4' }
  ];


  return (
    <LabeledSelect
      { ...props }
      options={ options }
    />
  );
};
